var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubblesMobileDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 639,
    viewBox: "0 0 428 639",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_95636)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_305_95636)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M219.428 448.831C218.947 448.275 218.313 447.877 217.608 447.686C216.904 447.496 216.159 447.522 215.469 447.761C214.778 448 214.173 448.442 213.73 449.03C213.288 449.618 213.026 450.326 212.98 451.065C212.934 451.803 213.104 452.539 213.47 453.179C213.836 453.82 214.381 454.335 215.036 454.661C215.691 454.987 216.426 455.109 217.149 455.01C217.872 454.912 218.55 454.599 219.098 454.109C219.831 453.454 220.278 452.529 220.34 451.54C220.402 450.55 220.074 449.575 219.428 448.831Z",
    fill: "url(#paint0_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M229.776 453.355C229.488 453.023 229.109 452.785 228.688 452.672C228.267 452.559 227.822 452.574 227.41 452.718C226.997 452.861 226.636 453.125 226.372 453.476C226.107 453.827 225.952 454.251 225.924 454.692C225.897 455.133 225.999 455.573 226.218 455.955C226.437 456.337 226.762 456.645 227.154 456.84C227.545 457.034 227.984 457.107 228.416 457.048C228.848 456.989 229.253 456.801 229.58 456.509C229.797 456.315 229.975 456.08 230.102 455.816C230.23 455.553 230.305 455.266 230.323 454.973C230.341 454.68 230.302 454.386 230.208 454.109C230.114 453.831 229.967 453.575 229.776 453.355Z",
    fill: "url(#paint1_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M224.194 457.802C224.009 457.587 223.766 457.433 223.495 457.359C223.223 457.285 222.937 457.294 222.67 457.385C222.404 457.476 222.171 457.646 222 457.872C221.829 458.098 221.727 458.371 221.709 458.655C221.691 458.94 221.756 459.223 221.897 459.47C222.037 459.717 222.247 459.916 222.499 460.042C222.751 460.167 223.035 460.214 223.313 460.177C223.592 460.139 223.853 460.018 224.064 459.83C224.344 459.577 224.515 459.223 224.54 458.843C224.564 458.463 224.44 458.089 224.194 457.802Z",
    fill: "url(#paint2_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M255.875 449.233C255.69 449.018 255.446 448.865 255.174 448.791C254.903 448.717 254.616 448.727 254.35 448.819C254.084 448.911 253.851 449.081 253.68 449.308C253.51 449.534 253.409 449.807 253.391 450.091C253.374 450.376 253.44 450.659 253.581 450.906C253.722 451.152 253.932 451.351 254.185 451.476C254.437 451.601 254.721 451.648 254.999 451.609C255.277 451.571 255.538 451.449 255.749 451.26C255.888 451.136 256.002 450.984 256.084 450.815C256.166 450.646 256.214 450.461 256.226 450.273C256.238 450.085 256.213 449.896 256.153 449.718C256.092 449.539 255.998 449.374 255.875 449.233Z",
    fill: "url(#paint3_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M214.708 468.188C214.674 468.134 214.629 468.089 214.576 468.054C214.523 468.02 214.464 467.998 214.401 467.989C214.339 467.98 214.276 467.985 214.216 468.004C214.156 468.022 214.1 468.054 214.053 468.096C214.006 468.138 213.969 468.19 213.943 468.248C213.918 468.307 213.905 468.37 213.906 468.434C213.907 468.497 213.922 468.56 213.949 468.618C213.976 468.675 214.015 468.726 214.064 468.766C214.14 468.852 214.245 468.903 214.358 468.911C214.471 468.918 214.583 468.881 214.669 468.806C214.754 468.729 214.806 468.621 214.813 468.505C214.82 468.389 214.783 468.276 214.708 468.188Z",
    fill: "url(#paint4_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M232.58 466.147C232.504 466.061 232.397 466.008 232.283 466.001C232.169 465.993 232.057 466.032 231.97 466.108C231.886 466.185 231.835 466.292 231.828 466.407C231.821 466.521 231.858 466.634 231.931 466.722C232.007 466.808 232.114 466.861 232.228 466.868C232.342 466.876 232.454 466.837 232.541 466.761C232.625 466.684 232.676 466.577 232.683 466.463C232.69 466.348 232.653 466.235 232.58 466.147Z",
    fill: "url(#paint5_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M266.619 461.614C266.563 461.548 266.488 461.5 266.405 461.477C266.321 461.454 266.233 461.457 266.151 461.484C266.069 461.512 265.997 461.564 265.945 461.634C265.892 461.704 265.861 461.787 265.855 461.875C265.85 461.962 265.87 462.05 265.914 462.125C265.957 462.201 266.022 462.262 266.099 462.3C266.177 462.339 266.264 462.353 266.35 462.341C266.435 462.329 266.515 462.291 266.58 462.233C266.665 462.155 266.717 462.047 266.724 461.932C266.732 461.816 266.694 461.702 266.619 461.614Z",
    fill: "url(#paint6_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M261.103 465.427C261.027 465.341 260.921 465.288 260.807 465.281C260.693 465.273 260.58 465.312 260.494 465.387C260.41 465.465 260.359 465.572 260.351 465.686C260.344 465.801 260.381 465.914 260.455 466.001C260.531 466.088 260.637 466.141 260.751 466.148C260.865 466.155 260.978 466.117 261.064 466.041C261.148 465.964 261.199 465.857 261.206 465.742C261.214 465.628 261.177 465.515 261.103 465.427Z",
    fill: "url(#paint7_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M234.578 479.443C233.894 478.661 232.996 478.101 231.998 477.835C231 477.569 229.948 477.608 228.972 477.949C227.996 478.289 227.142 478.915 226.516 479.747C225.891 480.579 225.522 481.581 225.457 482.625C225.391 483.67 225.632 484.711 226.149 485.617C226.666 486.523 227.435 487.253 228.36 487.716C229.286 488.179 230.325 488.353 231.348 488.218C232.371 488.082 233.331 487.642 234.108 486.953C234.627 486.493 235.051 485.933 235.356 485.305C235.661 484.678 235.84 483.996 235.884 483.298C235.928 482.6 235.835 481.9 235.611 481.238C235.387 480.577 235.036 479.967 234.578 479.443Z",
    fill: "url(#paint8_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M245.312 460.599C244.972 460.204 244.523 459.92 244.023 459.785C243.523 459.649 242.995 459.667 242.505 459.836C242.015 460.005 241.586 460.318 241.272 460.735C240.958 461.152 240.773 461.655 240.74 462.179C240.708 462.703 240.83 463.225 241.09 463.678C241.35 464.132 241.737 464.497 242.203 464.727C242.668 464.957 243.189 465.042 243.702 464.971C244.215 464.899 244.695 464.675 245.082 464.327C245.597 463.862 245.911 463.209 245.954 462.511C245.998 461.812 245.767 461.125 245.312 460.599Z",
    fill: "url(#paint9_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M201.78 478.383C201.44 477.988 200.991 477.704 200.492 477.568C199.992 477.431 199.464 477.448 198.974 477.617C198.484 477.786 198.054 478.098 197.74 478.515C197.425 478.932 197.24 479.434 197.207 479.958C197.173 480.482 197.295 481.004 197.554 481.458C197.814 481.912 198.201 482.277 198.665 482.508C199.13 482.739 199.652 482.824 200.165 482.753C200.677 482.683 201.158 482.459 201.545 482.111C202.061 481.647 202.376 480.995 202.42 480.296C202.464 479.598 202.234 478.91 201.78 478.383Z",
    fill: "url(#paint10_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230.359 421.999C230.018 421.604 229.57 421.321 229.07 421.185C228.57 421.05 228.042 421.067 227.552 421.237C227.062 421.406 226.633 421.719 226.319 422.136C226.005 422.553 225.82 423.056 225.787 423.58C225.755 424.103 225.877 424.625 226.137 425.079C226.397 425.533 226.784 425.898 227.249 426.128C227.714 426.358 228.236 426.443 228.749 426.372C229.261 426.3 229.742 426.076 230.128 425.728C230.644 425.263 230.958 424.61 231.001 423.912C231.044 423.213 230.814 422.526 230.359 421.999Z",
    fill: "url(#paint11_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.214 439.607C183.873 439.212 183.424 438.929 182.924 438.793C182.425 438.658 181.896 438.675 181.407 438.845C180.917 439.014 180.488 439.327 180.173 439.744C179.859 440.161 179.674 440.664 179.642 441.187C179.609 441.711 179.731 442.233 179.991 442.687C180.252 443.141 180.639 443.506 181.104 443.736C181.569 443.966 182.091 444.051 182.603 443.98C183.116 443.908 183.596 443.684 183.983 443.336C184.499 442.871 184.812 442.218 184.856 441.52C184.899 440.821 184.668 440.134 184.214 439.607Z",
    fill: "url(#paint12_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.182 405.001C190.018 404.813 189.803 404.678 189.563 404.613C189.324 404.549 189.071 404.558 188.836 404.639C188.602 404.721 188.396 404.871 188.246 405.071C188.095 405.27 188.007 405.511 187.991 405.762C187.975 406.013 188.033 406.263 188.157 406.481C188.281 406.698 188.466 406.874 188.689 406.985C188.911 407.096 189.161 407.137 189.407 407.104C189.652 407.071 189.883 406.965 190.069 406.799C190.194 406.689 190.295 406.555 190.368 406.405C190.442 406.255 190.485 406.091 190.495 405.924C190.506 405.757 190.483 405.589 190.43 405.431C190.376 405.273 190.292 405.127 190.182 405.001Z",
    fill: "url(#paint13_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M266.028 472.76C265.829 472.53 265.567 472.365 265.276 472.286C264.985 472.207 264.677 472.218 264.392 472.316C264.107 472.415 263.857 472.597 263.674 472.84C263.49 473.082 263.382 473.375 263.363 473.68C263.343 473.985 263.413 474.289 263.564 474.554C263.715 474.819 263.94 475.032 264.21 475.167C264.48 475.302 264.784 475.353 265.083 475.313C265.382 475.273 265.662 475.143 265.888 474.942C266.039 474.808 266.162 474.645 266.25 474.463C266.339 474.281 266.391 474.083 266.404 473.88C266.417 473.677 266.39 473.474 266.325 473.282C266.261 473.09 266.16 472.912 266.028 472.76Z",
    fill: "url(#paint14_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.736 474.355C222.535 474.129 222.273 473.969 221.982 473.894C221.692 473.819 221.386 473.833 221.103 473.933C220.82 474.034 220.573 474.217 220.392 474.459C220.211 474.702 220.104 474.993 220.086 475.297C220.067 475.6 220.138 475.903 220.288 476.166C220.438 476.429 220.661 476.642 220.929 476.777C221.198 476.912 221.5 476.964 221.797 476.926C222.095 476.888 222.374 476.762 222.601 476.564C222.755 476.429 222.881 476.264 222.972 476.08C223.062 475.895 223.115 475.694 223.127 475.488C223.14 475.282 223.112 475.076 223.045 474.881C222.978 474.687 222.873 474.508 222.736 474.355Z",
    fill: "url(#paint15_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M249.95 484.002C249.809 483.84 249.625 483.723 249.419 483.668C249.213 483.612 248.996 483.62 248.795 483.689C248.593 483.759 248.417 483.888 248.287 484.059C248.158 484.231 248.082 484.438 248.069 484.653C248.055 484.869 248.105 485.083 248.212 485.27C248.319 485.457 248.478 485.607 248.669 485.702C248.86 485.797 249.075 485.832 249.286 485.803C249.497 485.774 249.695 485.682 249.854 485.539C250.067 485.348 250.197 485.079 250.215 484.791C250.233 484.503 250.138 484.219 249.95 484.002Z",
    fill: "url(#paint16_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M255.326 452.365C255.185 452.204 255 452.088 254.794 452.033C254.589 451.978 254.372 451.986 254.171 452.056C253.97 452.126 253.794 452.254 253.665 452.426C253.536 452.597 253.46 452.804 253.446 453.019C253.433 453.234 253.483 453.449 253.59 453.635C253.696 453.822 253.855 453.972 254.046 454.067C254.237 454.162 254.451 454.198 254.662 454.169C254.873 454.141 255.07 454.049 255.23 453.907C255.443 453.715 255.573 453.445 255.591 453.156C255.609 452.867 255.514 452.583 255.326 452.365Z",
    fill: "url(#paint17_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.843 477.287C251.497 476.889 251.042 476.604 250.536 476.469C250.03 476.333 249.496 476.352 249.001 476.525C248.506 476.697 248.073 477.014 247.755 477.436C247.438 477.859 247.251 478.367 247.218 478.897C247.185 479.427 247.308 479.955 247.571 480.414C247.833 480.873 248.224 481.243 248.694 481.477C249.164 481.71 249.692 481.798 250.21 481.727C250.729 481.657 251.216 481.432 251.608 481.082C251.87 480.848 252.083 480.565 252.236 480.248C252.39 479.931 252.48 479.586 252.501 479.234C252.523 478.881 252.476 478.528 252.364 478.194C252.251 477.86 252.074 477.552 251.843 477.287Z",
    fill: "url(#paint18_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M214.839 400.959C214.355 400.406 213.721 400.011 213.017 399.824C212.313 399.636 211.57 399.664 210.881 399.905C210.193 400.145 209.59 400.587 209.148 401.174C208.707 401.762 208.447 402.469 208.401 403.206C208.355 403.944 208.525 404.678 208.89 405.318C209.255 405.957 209.798 406.472 210.451 406.799C211.104 407.125 211.838 407.249 212.56 407.153C213.282 407.057 213.96 406.746 214.508 406.26C214.874 405.934 215.172 405.539 215.387 405.096C215.602 404.653 215.728 404.172 215.759 403.679C215.79 403.186 215.724 402.693 215.566 402.226C215.408 401.759 215.161 401.328 214.839 400.959Z",
    fill: "url(#paint19_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M225.205 405.496C224.917 405.165 224.539 404.927 224.118 404.814C223.697 404.7 223.252 404.716 222.839 404.859C222.427 405.002 222.066 405.266 221.802 405.618C221.537 405.969 221.381 406.392 221.354 406.833C221.327 407.275 221.429 407.714 221.648 408.097C221.866 408.479 222.192 408.787 222.583 408.981C222.975 409.176 223.414 409.248 223.846 409.189C224.278 409.13 224.683 408.943 225.009 408.65C225.448 408.258 225.714 407.706 225.751 407.115C225.788 406.523 225.591 405.941 225.205 405.496Z",
    fill: "url(#paint20_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M219.629 409.959C219.444 409.744 219.201 409.59 218.929 409.515C218.658 409.441 218.371 409.45 218.105 409.542C217.839 409.633 217.605 409.803 217.434 410.029C217.263 410.255 217.162 410.527 217.144 410.812C217.125 411.096 217.191 411.38 217.331 411.627C217.472 411.874 217.682 412.073 217.934 412.198C218.186 412.324 218.469 412.371 218.748 412.333C219.026 412.296 219.287 412.175 219.498 411.986C219.78 411.734 219.952 411.38 219.976 411C220.001 410.62 219.876 410.245 219.629 409.959Z",
    fill: "url(#paint21_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M251.304 401.371C251.118 401.157 250.874 401.004 250.603 400.931C250.331 400.858 250.045 400.868 249.779 400.96C249.514 401.053 249.281 401.223 249.111 401.449C248.94 401.675 248.84 401.948 248.822 402.232C248.804 402.517 248.87 402.8 249.011 403.046C249.152 403.292 249.362 403.491 249.614 403.616C249.866 403.741 250.149 403.788 250.428 403.75C250.706 403.712 250.967 403.591 251.177 403.403C251.317 403.278 251.432 403.127 251.514 402.957C251.597 402.787 251.645 402.602 251.657 402.414C251.668 402.225 251.643 402.035 251.583 401.857C251.522 401.678 251.427 401.513 251.304 401.371Z",
    fill: "url(#paint22_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.138 420.33C210.105 420.275 210.061 420.228 210.008 420.192C209.955 420.157 209.895 420.133 209.832 420.123C209.769 420.113 209.705 420.118 209.644 420.136C209.583 420.154 209.527 420.185 209.479 420.228C209.431 420.271 209.393 420.323 209.368 420.382C209.342 420.441 209.33 420.505 209.331 420.57C209.333 420.634 209.348 420.698 209.376 420.755C209.404 420.813 209.444 420.864 209.494 420.904C209.527 420.96 209.571 421.007 209.624 421.042C209.677 421.078 209.737 421.102 209.8 421.111C209.863 421.121 209.927 421.117 209.988 421.099C210.049 421.081 210.105 421.049 210.153 421.007C210.201 420.964 210.239 420.911 210.264 420.852C210.29 420.793 210.302 420.729 210.301 420.665C210.3 420.6 210.284 420.537 210.256 420.479C210.228 420.421 210.188 420.371 210.138 420.33Z",
    fill: "url(#paint23_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M228.007 418.284C227.951 418.217 227.876 418.169 227.793 418.145C227.709 418.122 227.621 418.124 227.538 418.151C227.456 418.179 227.384 418.231 227.331 418.301C227.278 418.37 227.247 418.454 227.241 418.542C227.236 418.63 227.256 418.717 227.3 418.793C227.343 418.869 227.408 418.93 227.486 418.968C227.564 419.007 227.652 419.02 227.738 419.008C227.823 418.995 227.903 418.957 227.968 418.898C228.052 418.821 228.103 418.714 228.11 418.599C228.117 418.485 228.08 418.372 228.007 418.284Z",
    fill: "url(#paint24_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M262.049 413.756C261.993 413.689 261.918 413.641 261.835 413.617C261.751 413.594 261.663 413.596 261.58 413.624C261.498 413.651 261.426 413.703 261.373 413.773C261.32 413.842 261.289 413.927 261.283 414.014C261.278 414.102 261.298 414.19 261.342 414.265C261.385 414.341 261.45 414.402 261.528 414.441C261.606 414.479 261.694 414.493 261.78 414.48C261.865 414.468 261.945 414.429 262.01 414.37C262.094 414.293 262.145 414.186 262.152 414.071C262.159 413.957 262.122 413.844 262.049 413.756Z",
    fill: "url(#paint25_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M256.533 417.564C256.456 417.479 256.349 417.427 256.235 417.42C256.121 417.414 256.009 417.453 255.923 417.529C255.84 417.606 255.788 417.713 255.781 417.828C255.774 417.943 255.811 418.056 255.884 418.143C255.964 418.214 256.066 418.253 256.172 418.254C256.278 418.254 256.38 418.215 256.46 418.144C256.539 418.073 256.591 417.975 256.604 417.868C256.618 417.761 256.592 417.653 256.533 417.564Z",
    fill: "url(#paint26_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230.007 431.603C229.322 430.82 228.425 430.26 227.427 429.994C226.429 429.728 225.376 429.768 224.401 430.108C223.425 430.449 222.571 431.074 221.945 431.907C221.32 432.739 220.951 433.741 220.886 434.785C220.82 435.83 221.061 436.871 221.578 437.777C222.094 438.682 222.864 439.413 223.789 439.876C224.714 440.339 225.754 440.513 226.777 440.377C227.8 440.242 228.76 439.801 229.537 439.113C230.056 438.652 230.48 438.092 230.785 437.465C231.09 436.838 231.269 436.155 231.313 435.457C231.356 434.759 231.264 434.059 231.039 433.398C230.815 432.736 230.464 432.126 230.007 431.603Z",
    fill: "url(#paint27_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.721 412.742C240.38 412.347 239.931 412.063 239.431 411.928C238.931 411.792 238.403 411.81 237.913 411.979C237.424 412.148 236.995 412.461 236.68 412.878C236.366 413.295 236.181 413.798 236.149 414.322C236.116 414.846 236.238 415.368 236.498 415.821C236.758 416.275 237.146 416.64 237.611 416.87C238.076 417.1 238.598 417.185 239.11 417.114C239.623 417.042 240.103 416.818 240.49 416.47C241.006 416.005 241.319 415.352 241.363 414.654C241.406 413.955 241.175 413.268 240.721 412.742Z",
    fill: "url(#paint28_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.185 430.521C196.845 430.126 196.396 429.842 195.897 429.706C195.397 429.569 194.869 429.587 194.379 429.755C193.889 429.924 193.46 430.237 193.145 430.653C192.83 431.07 192.645 431.572 192.612 432.096C192.579 432.62 192.7 433.142 192.96 433.596C193.219 434.05 193.606 434.415 194.071 434.646C194.535 434.877 195.057 434.962 195.57 434.892C196.083 434.821 196.563 434.597 196.95 434.249C197.467 433.785 197.781 433.133 197.825 432.434C197.869 431.736 197.639 431.048 197.185 430.521Z",
    fill: "url(#paint29_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M225.788 374.141C225.448 373.746 224.999 373.462 224.499 373.326C223.999 373.189 223.471 373.207 222.98 373.376C222.49 373.545 222.061 373.858 221.746 374.275C221.432 374.692 221.247 375.195 221.214 375.719C221.182 376.243 221.303 376.765 221.564 377.219C221.824 377.673 222.212 378.038 222.677 378.268C223.143 378.498 223.665 378.583 224.178 378.511C224.69 378.439 225.171 378.215 225.557 377.865C226.072 377.401 226.385 376.749 226.428 376.052C226.471 375.354 226.241 374.668 225.788 374.141Z",
    fill: "url(#paint30_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M179.642 391.749C179.301 391.353 178.852 391.069 178.352 390.933C177.853 390.797 177.324 390.814 176.834 390.983C176.344 391.152 175.914 391.465 175.6 391.882C175.285 392.3 175.1 392.802 175.068 393.326C175.035 393.851 175.157 394.373 175.417 394.827C175.678 395.281 176.065 395.646 176.531 395.876C176.996 396.106 177.518 396.19 178.031 396.118C178.544 396.047 179.024 395.822 179.411 395.473C179.925 395.008 180.238 394.356 180.281 393.659C180.325 392.962 180.095 392.275 179.642 391.749Z",
    fill: "url(#paint31_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61 357.139C185.446 356.95 185.231 356.815 184.991 356.75C184.752 356.686 184.499 356.695 184.264 356.776C184.03 356.858 183.824 357.008 183.674 357.208C183.523 357.408 183.434 357.648 183.419 357.899C183.403 358.15 183.461 358.4 183.585 358.618C183.709 358.835 183.894 359.011 184.116 359.122C184.339 359.233 184.589 359.274 184.834 359.241C185.08 359.208 185.311 359.102 185.497 358.936C185.621 358.826 185.722 358.692 185.795 358.542C185.868 358.392 185.911 358.228 185.921 358.061C185.932 357.894 185.909 357.727 185.856 357.568C185.803 357.41 185.719 357.264 185.61 357.139Z",
    fill: "url(#paint32_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M261.456 424.899C261.257 424.67 260.995 424.506 260.704 424.427C260.413 424.349 260.106 424.36 259.821 424.459C259.536 424.557 259.287 424.739 259.104 424.982C258.921 425.225 258.813 425.517 258.793 425.822C258.774 426.127 258.844 426.431 258.994 426.695C259.145 426.96 259.37 427.173 259.64 427.308C259.91 427.443 260.213 427.494 260.512 427.455C260.81 427.415 261.09 427.286 261.317 427.085C261.621 426.814 261.806 426.431 261.832 426.021C261.859 425.611 261.723 425.207 261.456 424.899Z",
    fill: "url(#paint33_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.166 426.497C217.966 426.267 217.704 426.103 217.413 426.025C217.122 425.946 216.814 425.957 216.529 426.057C216.244 426.156 215.994 426.338 215.811 426.581C215.629 426.825 215.521 427.117 215.502 427.422C215.483 427.728 215.554 428.032 215.705 428.296C215.857 428.56 216.082 428.773 216.353 428.908C216.623 429.042 216.927 429.092 217.226 429.052C217.524 429.011 217.805 428.881 218.031 428.679C218.181 428.545 218.304 428.382 218.392 428.2C218.481 428.017 218.533 427.819 218.545 427.616C218.558 427.413 218.531 427.21 218.466 427.018C218.4 426.826 218.298 426.649 218.166 426.497Z",
    fill: "url(#paint34_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M245.379 436.139C245.239 435.978 245.054 435.862 244.848 435.807C244.643 435.752 244.426 435.76 244.225 435.829C244.024 435.899 243.847 436.028 243.718 436.2C243.59 436.371 243.514 436.578 243.5 436.793C243.487 437.008 243.537 437.223 243.643 437.409C243.75 437.596 243.909 437.746 244.1 437.841C244.29 437.936 244.505 437.972 244.715 437.943C244.926 437.915 245.124 437.823 245.283 437.681C245.497 437.489 245.627 437.219 245.645 436.93C245.663 436.641 245.567 436.357 245.379 436.139Z",
    fill: "url(#paint35_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M250.764 404.511C250.624 404.349 250.439 404.232 250.233 404.177C250.028 404.121 249.811 404.128 249.609 404.198C249.408 404.268 249.231 404.397 249.102 404.568C248.973 404.74 248.896 404.946 248.883 405.162C248.87 405.377 248.919 405.592 249.026 405.779C249.133 405.966 249.292 406.116 249.484 406.211C249.675 406.306 249.889 406.341 250.1 406.312C250.311 406.283 250.509 406.191 250.668 406.048C250.774 405.954 250.861 405.839 250.923 405.711C250.986 405.582 251.022 405.443 251.031 405.3C251.04 405.157 251.021 405.014 250.975 404.878C250.929 404.743 250.858 404.618 250.764 404.511Z",
    fill: "url(#paint36_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.254 429.429C246.908 429.031 246.453 428.745 245.947 428.609C245.441 428.473 244.906 428.492 244.411 428.664C243.916 428.836 243.482 429.153 243.164 429.575C242.846 429.998 242.659 430.506 242.626 431.036C242.593 431.566 242.716 432.095 242.979 432.554C243.242 433.013 243.633 433.383 244.104 433.617C244.574 433.85 245.102 433.937 245.621 433.867C246.139 433.796 246.626 433.571 247.019 433.219C247.545 432.748 247.866 432.084 247.91 431.374C247.954 430.663 247.718 429.963 247.254 429.429Z",
    fill: "url(#paint37_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M220.783 348.556C220.3 348.003 219.666 347.608 218.962 347.42C218.257 347.233 217.514 347.261 216.826 347.501C216.137 347.742 215.534 348.184 215.093 348.771C214.651 349.359 214.391 350.066 214.345 350.803C214.299 351.54 214.469 352.275 214.834 352.914C215.199 353.554 215.742 354.069 216.395 354.396C217.048 354.722 217.782 354.845 218.504 354.749C219.226 354.653 219.904 354.343 220.452 353.856C220.818 353.531 221.117 353.136 221.331 352.693C221.546 352.25 221.673 351.768 221.703 351.276C221.734 350.783 221.669 350.289 221.511 349.822C221.353 349.356 221.105 348.925 220.783 348.556Z",
    fill: "url(#paint38_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M231.129 353.093C230.841 352.761 230.463 352.524 230.041 352.41C229.62 352.297 229.176 352.313 228.763 352.456C228.351 352.599 227.99 352.863 227.725 353.214C227.461 353.566 227.305 353.989 227.278 354.43C227.25 354.871 227.353 355.311 227.571 355.693C227.79 356.076 228.116 356.383 228.507 356.578C228.899 356.772 229.338 356.845 229.77 356.786C230.202 356.727 230.606 356.54 230.933 356.247C231.151 356.053 231.328 355.818 231.456 355.554C231.583 355.291 231.658 355.004 231.677 354.711C231.695 354.418 231.656 354.125 231.562 353.847C231.468 353.569 231.321 353.313 231.129 353.093Z",
    fill: "url(#paint39_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M225.549 357.536C225.363 357.322 225.119 357.169 224.848 357.096C224.577 357.022 224.29 357.033 224.024 357.125C223.759 357.217 223.526 357.387 223.356 357.614C223.185 357.84 223.085 358.113 223.067 358.397C223.05 358.681 223.115 358.964 223.256 359.211C223.397 359.457 223.607 359.655 223.859 359.781C224.111 359.906 224.394 359.953 224.673 359.915C224.951 359.877 225.212 359.756 225.422 359.568C225.705 359.315 225.876 358.959 225.9 358.578C225.924 358.197 225.797 357.822 225.549 357.536Z",
    fill: "url(#paint40_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M257.229 348.971C257.044 348.757 256.8 348.603 256.529 348.529C256.258 348.456 255.971 348.465 255.705 348.557C255.439 348.649 255.206 348.819 255.035 349.046C254.864 349.272 254.764 349.545 254.746 349.83C254.728 350.114 254.794 350.398 254.935 350.644C255.077 350.891 255.287 351.089 255.539 351.214C255.792 351.34 256.075 351.386 256.353 351.347C256.632 351.309 256.893 351.188 257.103 350.999C257.384 350.746 257.555 350.391 257.579 350.011C257.602 349.631 257.477 349.257 257.229 348.971Z",
    fill: "url(#paint41_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M216.061 367.927C215.985 367.841 215.879 367.79 215.766 367.782C215.653 367.775 215.542 367.812 215.456 367.887C215.371 367.964 215.319 368.072 215.311 368.188C215.304 368.304 215.342 368.418 215.417 368.505C215.497 368.573 215.598 368.609 215.702 368.607C215.806 368.605 215.905 368.566 215.983 368.496C216.061 368.426 216.112 368.33 216.126 368.226C216.14 368.121 216.117 368.015 216.061 367.927Z",
    fill: "url(#paint42_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M233.934 365.882C233.858 365.796 233.752 365.745 233.639 365.737C233.526 365.73 233.415 365.767 233.329 365.842C233.244 365.919 233.192 366.027 233.184 366.143C233.177 366.259 233.215 366.373 233.29 366.46C233.366 366.545 233.471 366.597 233.584 366.605C233.697 366.612 233.809 366.575 233.895 366.5C233.98 366.423 234.032 366.315 234.039 366.199C234.047 366.083 234.009 365.969 233.934 365.882Z",
    fill: "url(#paint43_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M267.972 361.366C267.896 361.281 267.79 361.23 267.677 361.222C267.564 361.215 267.453 361.252 267.367 361.327C267.282 361.404 267.23 361.512 267.223 361.628C267.215 361.743 267.253 361.857 267.328 361.945C267.404 362.03 267.509 362.082 267.622 362.09C267.735 362.097 267.847 362.059 267.933 361.985C268.018 361.908 268.07 361.8 268.077 361.684C268.085 361.568 268.047 361.454 267.972 361.366Z",
    fill: "url(#paint44_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M262.459 365.166C262.383 365.079 262.276 365.026 262.162 365.019C262.048 365.012 261.936 365.05 261.849 365.126C261.765 365.203 261.714 365.31 261.707 365.425C261.7 365.539 261.737 365.652 261.81 365.74C261.886 365.826 261.993 365.879 262.107 365.886C262.221 365.894 262.333 365.855 262.42 365.78C262.503 365.702 262.555 365.595 262.562 365.481C262.569 365.366 262.532 365.253 262.459 365.166Z",
    fill: "url(#paint45_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M235.932 379.177C235.247 378.394 234.349 377.835 233.352 377.569C232.354 377.303 231.301 377.342 230.325 377.683C229.35 378.023 228.496 378.649 227.87 379.481C227.244 380.313 226.876 381.315 226.81 382.359C226.745 383.404 226.986 384.445 227.502 385.351C228.019 386.257 228.789 386.987 229.714 387.45C230.639 387.913 231.679 388.087 232.702 387.951C233.724 387.816 234.685 387.376 235.462 386.687C235.981 386.227 236.405 385.667 236.71 385.039C237.014 384.412 237.194 383.73 237.238 383.031C237.281 382.333 237.188 381.633 236.964 380.972C236.74 380.311 236.389 379.701 235.932 379.177Z",
    fill: "url(#paint46_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M246.646 360.337C246.306 359.942 245.857 359.659 245.357 359.523C244.857 359.387 244.329 359.405 243.839 359.574C243.349 359.743 242.92 360.056 242.606 360.474C242.292 360.891 242.107 361.393 242.074 361.917C242.042 362.441 242.164 362.963 242.424 363.416C242.684 363.87 243.071 364.235 243.537 364.465C244.002 364.695 244.523 364.78 245.036 364.709C245.549 364.638 246.029 364.414 246.416 364.065C246.931 363.6 247.245 362.948 247.288 362.249C247.332 361.551 247.101 360.863 246.646 360.337Z",
    fill: "url(#paint47_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M203.111 378.121C202.77 377.726 202.322 377.443 201.822 377.307C201.322 377.171 200.794 377.189 200.304 377.358C199.814 377.528 199.385 377.841 199.071 378.258C198.757 378.675 198.572 379.177 198.539 379.701C198.507 380.225 198.629 380.747 198.889 381.201C199.149 381.654 199.536 382.019 200.001 382.25C200.466 382.48 200.988 382.564 201.501 382.493C202.013 382.422 202.494 382.198 202.88 381.849C203.396 381.385 203.71 380.732 203.753 380.033C203.796 379.335 203.566 378.647 203.111 378.121Z",
    fill: "url(#paint48_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M231.718 321.738C231.377 321.343 230.929 321.059 230.429 320.922C229.929 320.786 229.401 320.803 228.911 320.972C228.421 321.141 227.992 321.453 227.677 321.87C227.363 322.287 227.177 322.789 227.144 323.313C227.111 323.837 227.232 324.359 227.492 324.813C227.751 325.267 228.138 325.632 228.603 325.863C229.068 326.094 229.589 326.179 230.102 326.108C230.615 326.038 231.095 325.814 231.482 325.466C231.999 325.002 232.313 324.35 232.357 323.651C232.401 322.953 232.171 322.265 231.718 321.738Z",
    fill: "url(#paint49_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M185.565 339.347C185.224 338.952 184.776 338.668 184.276 338.533C183.776 338.397 183.248 338.415 182.758 338.584C182.268 338.753 181.839 339.066 181.525 339.483C181.211 339.9 181.026 340.403 180.993 340.927C180.961 341.451 181.083 341.973 181.343 342.426C181.603 342.88 181.99 343.245 182.455 343.475C182.92 343.705 183.442 343.79 183.955 343.719C184.468 343.647 184.948 343.423 185.335 343.075C185.85 342.61 186.164 341.957 186.207 341.259C186.251 340.56 186.02 339.873 185.565 339.347Z",
    fill: "url(#paint50_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.539 304.74C191.375 304.551 191.16 304.415 190.92 304.35C190.681 304.285 190.427 304.294 190.192 304.375C189.958 304.456 189.752 304.606 189.601 304.806C189.45 305.006 189.361 305.247 189.345 305.498C189.329 305.749 189.387 306 189.512 306.217C189.636 306.435 189.822 306.611 190.044 306.721C190.267 306.832 190.517 306.874 190.763 306.84C191.009 306.807 191.24 306.7 191.426 306.534C191.675 306.311 191.827 305.997 191.848 305.661C191.869 305.324 191.758 304.993 191.539 304.74Z",
    fill: "url(#paint51_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M267.381 372.498C267.182 372.268 266.92 372.104 266.629 372.026C266.338 371.947 266.03 371.958 265.745 372.058C265.46 372.157 265.21 372.339 265.027 372.582C264.844 372.826 264.737 373.118 264.718 373.423C264.699 373.729 264.77 374.033 264.921 374.297C265.073 374.561 265.298 374.774 265.568 374.909C265.839 375.043 266.143 375.093 266.442 375.052C266.74 375.012 267.02 374.882 267.246 374.68C267.397 374.546 267.52 374.383 267.608 374.201C267.697 374.018 267.749 373.82 267.761 373.617C267.774 373.414 267.747 373.211 267.681 373.019C267.616 372.827 267.514 372.65 267.381 372.498Z",
    fill: "url(#paint52_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.089 374.093C223.89 373.864 223.628 373.7 223.337 373.621C223.045 373.543 222.738 373.554 222.453 373.653C222.168 373.752 221.918 373.935 221.735 374.178C221.552 374.421 221.445 374.714 221.426 375.019C221.407 375.324 221.478 375.628 221.629 375.893C221.781 376.157 222.006 376.37 222.276 376.504C222.547 376.639 222.851 376.689 223.15 376.648C223.448 376.607 223.728 376.478 223.954 376.275C224.256 376.004 224.44 375.621 224.465 375.213C224.491 374.804 224.356 374.401 224.089 374.093Z",
    fill: "url(#paint53_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M251.303 383.736C251.162 383.574 250.978 383.459 250.772 383.403C250.567 383.348 250.35 383.356 250.148 383.426C249.947 383.496 249.771 383.625 249.642 383.796C249.513 383.968 249.437 384.174 249.424 384.39C249.411 384.605 249.46 384.819 249.567 385.006C249.674 385.193 249.833 385.343 250.023 385.438C250.214 385.533 250.429 385.568 250.639 385.54C250.85 385.511 251.048 385.42 251.207 385.278C251.421 385.086 251.551 384.816 251.569 384.527C251.587 384.238 251.491 383.954 251.303 383.736Z",
    fill: "url(#paint54_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M256.69 352.09C256.549 351.928 256.364 351.813 256.159 351.757C255.953 351.702 255.736 351.71 255.535 351.78C255.334 351.85 255.158 351.979 255.029 352.15C254.9 352.322 254.824 352.528 254.811 352.744C254.797 352.959 254.847 353.173 254.954 353.36C255.061 353.546 255.219 353.697 255.41 353.792C255.601 353.887 255.815 353.922 256.026 353.894C256.237 353.865 256.434 353.774 256.594 353.632C256.7 353.537 256.787 353.422 256.849 353.293C256.912 353.164 256.948 353.024 256.957 352.881C256.966 352.738 256.947 352.594 256.901 352.458C256.855 352.323 256.783 352.197 256.69 352.09Z",
    fill: "url(#paint55_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.184 377.027C252.839 376.628 252.384 376.342 251.878 376.205C251.372 376.069 250.838 376.087 250.342 376.258C249.847 376.43 249.413 376.747 249.094 377.169C248.776 377.59 248.589 378.099 248.555 378.629C248.522 379.159 248.644 379.687 248.906 380.147C249.169 380.606 249.56 380.977 250.03 381.211C250.499 381.445 251.027 381.533 251.546 381.463C252.065 381.393 252.552 381.168 252.945 380.817C253.471 380.346 253.792 379.683 253.836 378.972C253.881 378.262 253.647 377.562 253.184 377.027Z",
    fill: "url(#paint56_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M202.07 300.163C201.587 299.611 200.953 299.216 200.249 299.028C199.544 298.841 198.801 298.869 198.113 299.109C197.424 299.35 196.821 299.791 196.38 300.379C195.939 300.967 195.678 301.673 195.632 302.411C195.586 303.148 195.756 303.883 196.121 304.522C196.486 305.161 197.029 305.677 197.682 306.003C198.336 306.33 199.069 306.453 199.791 306.357C200.513 306.261 201.191 305.951 201.739 305.464C202.105 305.139 202.405 304.744 202.62 304.301C202.835 303.858 202.962 303.377 202.992 302.884C203.023 302.391 202.957 301.897 202.799 301.43C202.641 300.963 202.393 300.533 202.07 300.163Z",
    fill: "url(#paint57_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.418 304.7C212.13 304.368 211.752 304.13 211.331 304.017C210.909 303.903 210.465 303.919 210.052 304.062C209.64 304.205 209.279 304.469 209.014 304.821C208.75 305.172 208.594 305.595 208.567 306.036C208.539 306.478 208.642 306.917 208.86 307.3C209.079 307.682 209.405 307.99 209.796 308.184C210.188 308.379 210.627 308.451 211.059 308.392C211.491 308.333 211.896 308.146 212.222 307.854C212.44 307.66 212.617 307.424 212.745 307.161C212.872 306.897 212.947 306.611 212.966 306.318C212.984 306.025 212.945 305.731 212.851 305.453C212.757 305.176 212.61 304.919 212.418 304.7Z",
    fill: "url(#paint58_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M206.838 309.144C206.652 308.931 206.408 308.778 206.137 308.704C205.866 308.631 205.579 308.642 205.313 308.734C205.048 308.826 204.815 308.996 204.645 309.222C204.474 309.449 204.374 309.721 204.356 310.006C204.339 310.29 204.404 310.573 204.545 310.82C204.686 311.066 204.896 311.264 205.148 311.39C205.4 311.515 205.684 311.561 205.962 311.524C206.24 311.486 206.501 311.365 206.711 311.176C206.852 311.052 206.966 310.9 207.049 310.73C207.131 310.56 207.179 310.376 207.191 310.187C207.203 309.998 207.177 309.809 207.117 309.63C207.056 309.451 206.961 309.286 206.838 309.144Z",
    fill: "url(#paint59_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M199.189 477.615C199.004 477.401 198.76 477.247 198.489 477.173C198.218 477.1 197.932 477.109 197.666 477.201C197.4 477.293 197.167 477.462 196.996 477.688C196.825 477.914 196.724 478.187 196.706 478.471C196.688 478.755 196.753 479.038 196.894 479.285C197.034 479.532 197.243 479.731 197.495 479.856C197.747 479.982 198.03 480.03 198.308 479.992C198.586 479.955 198.848 479.835 199.059 479.647C199.341 479.395 199.514 479.039 199.539 478.658C199.563 478.277 199.437 477.902 199.189 477.615Z",
    fill: "url(#paint60_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.352 319.534C197.295 319.467 197.221 319.418 197.137 319.395C197.054 319.371 196.965 319.373 196.883 319.401C196.801 319.429 196.729 319.481 196.676 319.55C196.623 319.62 196.591 319.704 196.586 319.792C196.58 319.879 196.601 319.967 196.644 320.043C196.688 320.119 196.753 320.18 196.831 320.218C196.909 320.256 196.997 320.27 197.082 320.257C197.168 320.245 197.248 320.207 197.312 320.148C197.396 320.071 197.447 319.963 197.455 319.849C197.462 319.734 197.425 319.621 197.352 319.534Z",
    fill: "url(#paint61_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M215.223 317.489C215.147 317.404 215.041 317.352 214.928 317.345C214.815 317.337 214.704 317.375 214.618 317.449C214.533 317.527 214.481 317.635 214.474 317.75C214.466 317.866 214.504 317.98 214.579 318.068C214.659 318.135 214.76 318.171 214.864 318.169C214.968 318.168 215.068 318.128 215.145 318.059C215.223 317.989 215.274 317.893 215.288 317.788C215.302 317.684 215.279 317.578 215.223 317.489Z",
    fill: "url(#paint62_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M209.933 490C209.857 489.914 209.751 489.861 209.637 489.854C209.523 489.847 209.41 489.885 209.324 489.961C209.24 490.038 209.189 490.145 209.182 490.26C209.174 490.374 209.211 490.487 209.285 490.575C209.361 490.661 209.467 490.714 209.581 490.721C209.695 490.729 209.808 490.69 209.894 490.615C209.978 490.537 210.029 490.43 210.036 490.316C210.044 490.201 210.007 490.088 209.933 490Z",
    fill: "url(#paint63_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M204.412 493.808C204.356 493.742 204.281 493.694 204.197 493.671C204.114 493.648 204.026 493.65 203.944 493.678C203.862 493.706 203.79 493.758 203.738 493.828C203.685 493.897 203.654 493.981 203.648 494.069C203.643 494.156 203.663 494.243 203.706 494.319C203.75 494.395 203.815 494.456 203.892 494.494C203.97 494.533 204.057 494.547 204.143 494.535C204.228 494.522 204.308 494.485 204.373 494.426C204.458 494.349 204.51 494.241 204.517 494.125C204.525 494.01 204.487 493.896 204.412 493.808Z",
    fill: "url(#paint64_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.221 330.784C216.536 330.001 215.638 329.442 214.641 329.176C213.643 328.91 212.59 328.949 211.615 329.289C210.639 329.63 209.785 330.255 209.159 331.088C208.534 331.92 208.165 332.922 208.099 333.966C208.034 335.011 208.275 336.052 208.792 336.958C209.308 337.864 210.078 338.594 211.003 339.057C211.928 339.52 212.968 339.694 213.991 339.558C215.014 339.423 215.974 338.983 216.751 338.294C217.27 337.834 217.694 337.274 217.999 336.646C218.304 336.019 218.483 335.336 218.527 334.638C218.57 333.94 218.477 333.24 218.253 332.579C218.029 331.917 217.678 331.308 217.221 330.784Z",
    fill: "url(#paint65_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M188.607 488.985C188.267 488.59 187.818 488.306 187.319 488.17C186.819 488.033 186.291 488.05 185.801 488.219C185.311 488.388 184.882 488.7 184.567 489.117C184.252 489.534 184.067 490.036 184.034 490.56C184.001 491.084 184.122 491.606 184.381 492.06C184.641 492.514 185.028 492.879 185.493 493.11C185.957 493.341 186.479 493.426 186.992 493.355C187.504 493.285 187.985 493.061 188.372 492.713C188.889 492.249 189.203 491.597 189.247 490.898C189.291 490.2 189.061 489.512 188.607 488.985Z",
    fill: "url(#paint66_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M199.416 335.767C199.075 335.371 198.627 335.088 198.127 334.951C197.628 334.815 197.099 334.832 196.61 335.001C196.12 335.17 195.69 335.482 195.376 335.899C195.061 336.316 194.875 336.818 194.842 337.342C194.809 337.865 194.93 338.387 195.19 338.841C195.45 339.295 195.836 339.661 196.301 339.892C196.766 340.122 197.288 340.208 197.8 340.137C198.313 340.067 198.793 339.843 199.181 339.495C199.697 339.031 200.012 338.379 200.056 337.68C200.1 336.982 199.87 336.294 199.416 335.767Z",
    fill: "url(#paint67_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M209.341 501.142C209.14 500.916 208.878 500.755 208.588 500.679C208.297 500.604 207.991 500.617 207.708 500.717C207.425 500.817 207.178 500.999 206.996 501.241C206.815 501.484 206.708 501.775 206.689 502.078C206.67 502.382 206.739 502.684 206.889 502.948C207.038 503.212 207.261 503.425 207.529 503.56C207.797 503.696 208.099 503.749 208.397 503.711C208.694 503.674 208.974 503.548 209.202 503.35C209.355 503.216 209.481 503.051 209.571 502.867C209.662 502.682 209.715 502.481 209.728 502.276C209.741 502.07 209.713 501.864 209.647 501.669C209.58 501.474 209.476 501.295 209.341 501.142Z",
    fill: "url(#paint68_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.378 325.701C205.179 325.472 204.917 325.308 204.626 325.229C204.335 325.151 204.027 325.162 203.742 325.261C203.457 325.36 203.207 325.543 203.024 325.786C202.841 326.029 202.734 326.322 202.715 326.627C202.696 326.932 202.767 327.236 202.918 327.501C203.07 327.765 203.295 327.978 203.566 328.112C203.836 328.247 204.14 328.297 204.439 328.256C204.737 328.215 205.017 328.086 205.243 327.883C205.394 327.749 205.517 327.587 205.605 327.404C205.694 327.222 205.746 327.024 205.758 326.821C205.771 326.618 205.744 326.415 205.678 326.223C205.613 326.03 205.511 325.853 205.378 325.701Z",
    fill: "url(#paint69_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M249.231 306.003C248.748 305.451 248.114 305.056 247.41 304.868C246.706 304.681 245.962 304.709 245.274 304.949C244.585 305.189 243.982 305.631 243.541 306.219C243.1 306.806 242.84 307.513 242.794 308.251C242.747 308.988 242.918 309.723 243.282 310.362C243.647 311.001 244.19 311.517 244.844 311.843C245.497 312.17 246.23 312.293 246.952 312.197C247.674 312.101 248.352 311.79 248.9 311.304C249.266 310.979 249.565 310.583 249.78 310.141C249.995 309.698 250.121 309.216 250.152 308.723C250.182 308.231 250.117 307.737 249.959 307.27C249.801 306.803 249.554 306.373 249.231 306.003Z",
    fill: "url(#paint70_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M259.572 310.539C259.284 310.208 258.905 309.97 258.484 309.857C258.063 309.743 257.618 309.759 257.206 309.902C256.793 310.045 256.432 310.309 256.168 310.661C255.903 311.012 255.748 311.435 255.72 311.876C255.693 312.318 255.795 312.757 256.014 313.14C256.233 313.522 256.558 313.83 256.95 314.024C257.341 314.219 257.78 314.291 258.212 314.232C258.644 314.173 259.049 313.986 259.376 313.693C259.814 313.301 260.08 312.749 260.117 312.158C260.154 311.566 259.958 310.984 259.572 310.539Z",
    fill: "url(#paint71_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M253.991 314.984C253.805 314.771 253.562 314.617 253.29 314.544C253.019 314.471 252.732 314.481 252.467 314.574C252.201 314.666 251.968 314.836 251.798 315.062C251.628 315.289 251.527 315.561 251.51 315.846C251.492 316.13 251.558 316.413 251.699 316.659C251.84 316.906 252.05 317.104 252.302 317.229C252.554 317.355 252.837 317.401 253.115 317.363C253.393 317.325 253.654 317.205 253.865 317.016C254.147 316.764 254.319 316.408 254.342 316.027C254.366 315.646 254.24 315.271 253.991 314.984Z",
    fill: "url(#paint72_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M244.505 325.373C244.449 325.307 244.374 325.258 244.291 325.235C244.207 325.211 244.119 325.213 244.036 325.241C243.954 325.268 243.882 325.32 243.829 325.39C243.776 325.46 243.745 325.544 243.739 325.631C243.734 325.719 243.754 325.807 243.798 325.883C243.841 325.959 243.906 326.02 243.984 326.058C244.062 326.096 244.15 326.11 244.236 326.097C244.321 326.085 244.402 326.047 244.466 325.987C244.55 325.91 244.601 325.803 244.608 325.689C244.615 325.574 244.578 325.461 244.505 325.373Z",
    fill: "url(#paint73_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M262.374 323.328C262.298 323.243 262.193 323.191 262.08 323.184C261.967 323.176 261.855 323.214 261.769 323.288C261.684 323.365 261.632 323.474 261.625 323.589C261.618 323.705 261.655 323.819 261.73 323.907C261.81 323.974 261.911 324.01 262.015 324.008C262.119 324.007 262.219 323.967 262.297 323.897C262.375 323.828 262.425 323.732 262.439 323.627C262.454 323.523 262.431 323.417 262.374 323.328Z",
    fill: "url(#paint74_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M264.374 336.63C263.69 335.847 262.792 335.287 261.794 335.021C260.796 334.755 259.743 334.794 258.768 335.135C257.792 335.475 256.938 336.101 256.312 336.933C255.687 337.765 255.318 338.767 255.253 339.811C255.187 340.856 255.428 341.897 255.945 342.803C256.462 343.709 257.231 344.439 258.156 344.902C259.082 345.365 260.121 345.539 261.144 345.404C262.167 345.268 263.127 344.828 263.904 344.139C264.423 343.679 264.847 343.119 265.152 342.491C265.457 341.864 265.636 341.182 265.68 340.484C265.724 339.786 265.631 339.086 265.407 338.424C265.183 337.763 264.832 337.153 264.374 336.63Z",
    fill: "url(#paint75_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M246.562 341.608C246.221 341.213 245.773 340.93 245.273 340.794C244.773 340.658 244.245 340.676 243.755 340.845C243.265 341.014 242.836 341.327 242.522 341.745C242.208 342.162 242.023 342.664 241.99 343.188C241.958 343.712 242.08 344.234 242.34 344.687C242.6 345.141 242.987 345.506 243.453 345.736C243.918 345.966 244.439 346.051 244.952 345.98C245.465 345.909 245.945 345.685 246.332 345.336C246.847 344.871 247.161 344.219 247.204 343.52C247.248 342.822 247.017 342.134 246.562 341.608Z",
    fill: "url(#paint76_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.531 331.54C252.331 331.311 252.07 331.146 251.778 331.068C251.487 330.99 251.179 331.001 250.894 331.1C250.609 331.199 250.359 331.382 250.177 331.625C249.994 331.868 249.886 332.161 249.867 332.466C249.848 332.771 249.919 333.075 250.071 333.339C250.222 333.604 250.447 333.817 250.718 333.951C250.989 334.086 251.292 334.136 251.591 334.095C251.89 334.054 252.17 333.925 252.396 333.722C252.546 333.588 252.669 333.425 252.758 333.243C252.846 333.061 252.898 332.862 252.911 332.66C252.923 332.457 252.896 332.254 252.831 332.061C252.766 331.869 252.664 331.692 252.531 331.54Z",
    fill: "url(#paint77_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.258 512.385C193.117 512.224 192.933 512.108 192.727 512.053C192.522 511.998 192.305 512.006 192.104 512.076C191.902 512.146 191.726 512.274 191.597 512.446C191.468 512.617 191.392 512.824 191.379 513.039C191.366 513.254 191.416 513.469 191.522 513.655C191.629 513.842 191.788 513.992 191.979 514.087C192.169 514.182 192.384 514.218 192.594 514.189C192.805 514.161 193.003 514.069 193.162 513.927C193.269 513.832 193.355 513.717 193.418 513.588C193.48 513.46 193.517 513.32 193.525 513.176C193.534 513.033 193.515 512.89 193.469 512.754C193.424 512.618 193.352 512.493 193.258 512.385Z",
    fill: "url(#paint78_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M198.65 480.756C198.51 480.593 198.325 480.477 198.119 480.421C197.914 480.365 197.696 480.373 197.495 480.443C197.293 480.512 197.117 480.641 196.988 480.813C196.858 480.984 196.782 481.191 196.769 481.407C196.755 481.622 196.805 481.837 196.912 482.024C197.019 482.21 197.178 482.361 197.369 482.455C197.561 482.55 197.775 482.586 197.986 482.557C198.197 482.528 198.395 482.436 198.554 482.293C198.767 482.102 198.897 481.832 198.915 481.544C198.933 481.256 198.838 480.972 198.65 480.756Z",
    fill: "url(#paint79_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14 505.674C194.795 505.275 194.34 504.989 193.834 504.852C193.328 504.716 192.794 504.734 192.298 504.905C191.803 505.077 191.369 505.394 191.051 505.816C190.732 506.237 190.545 506.746 190.511 507.276C190.478 507.806 190.6 508.334 190.862 508.794C191.125 509.253 191.516 509.624 191.986 509.858C192.455 510.092 192.983 510.18 193.502 510.11C194.021 510.04 194.508 509.815 194.901 509.464C195.428 508.994 195.749 508.33 195.794 507.619C195.839 506.909 195.604 506.209 195.14 505.674Z",
    fill: "url(#paint80_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M256.219 482.257C256.034 482.042 255.79 481.888 255.519 481.813C255.248 481.739 254.961 481.748 254.695 481.84C254.429 481.931 254.195 482.101 254.024 482.327C253.853 482.553 253.752 482.825 253.733 483.11C253.715 483.394 253.78 483.678 253.921 483.925C254.062 484.172 254.272 484.37 254.524 484.496C254.776 484.622 255.059 484.669 255.338 484.631C255.616 484.593 255.877 484.473 256.088 484.284C256.369 484.032 256.54 483.677 256.564 483.298C256.589 482.918 256.464 482.544 256.219 482.257Z",
    fill: "url(#paint81_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M266.964 494.64C266.907 494.573 266.833 494.526 266.749 494.502C266.666 494.479 266.578 494.482 266.496 494.51C266.414 494.538 266.342 494.59 266.289 494.659C266.237 494.729 266.206 494.813 266.2 494.9C266.195 494.988 266.215 495.075 266.258 495.151C266.302 495.226 266.366 495.287 266.444 495.326C266.522 495.364 266.609 495.378 266.695 495.366C266.78 495.354 266.86 495.316 266.925 495.258C267.01 495.181 267.062 495.073 267.069 494.957C267.076 494.841 267.039 494.727 266.964 494.64Z",
    fill: "url(#paint82_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M261.442 498.451C261.386 498.384 261.312 498.336 261.228 498.312C261.145 498.289 261.056 498.291 260.974 498.318C260.892 498.346 260.819 498.398 260.767 498.468C260.714 498.537 260.682 498.621 260.677 498.709C260.671 498.797 260.691 498.884 260.735 498.96C260.779 499.036 260.844 499.097 260.922 499.135C261 499.174 261.087 499.187 261.173 499.175C261.259 499.162 261.339 499.124 261.403 499.065C261.487 498.988 261.538 498.881 261.546 498.766C261.553 498.652 261.516 498.539 261.442 498.451Z",
    fill: "url(#paint83_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M245.636 493.623C245.295 493.228 244.847 492.944 244.347 492.808C243.847 492.671 243.319 492.689 242.829 492.857C242.339 493.026 241.91 493.339 241.595 493.755C241.281 494.172 241.095 494.674 241.062 495.198C241.029 495.722 241.15 496.244 241.41 496.698C241.669 497.152 242.056 497.517 242.521 497.748C242.986 497.979 243.507 498.064 244.02 497.994C244.533 497.923 245.013 497.699 245.4 497.351C245.917 496.887 246.231 496.235 246.275 495.536C246.319 494.838 246.089 494.15 245.636 493.623Z",
    fill: "url(#paint84_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M266.366 505.785C266.166 505.555 265.905 505.391 265.613 505.313C265.322 505.234 265.014 505.246 264.729 505.345C264.444 505.444 264.194 505.626 264.012 505.87C263.829 506.113 263.721 506.405 263.702 506.711C263.683 507.016 263.754 507.32 263.905 507.584C264.057 507.849 264.282 508.061 264.553 508.196C264.823 508.33 265.127 508.38 265.426 508.34C265.725 508.299 266.005 508.169 266.231 507.967C266.381 507.833 266.504 507.67 266.593 507.488C266.681 507.305 266.733 507.107 266.745 506.904C266.758 506.701 266.731 506.498 266.666 506.306C266.601 506.114 266.499 505.937 266.366 505.785Z",
    fill: "url(#paint85_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M255.679 485.393C255.538 485.232 255.354 485.116 255.148 485.061C254.943 485.006 254.725 485.013 254.524 485.083C254.323 485.153 254.147 485.282 254.018 485.454C253.889 485.625 253.813 485.832 253.8 486.047C253.787 486.262 253.836 486.477 253.943 486.663C254.05 486.85 254.209 487 254.399 487.095C254.59 487.19 254.805 487.226 255.015 487.197C255.226 487.169 255.424 487.077 255.583 486.935C255.797 486.743 255.927 486.473 255.945 486.184C255.962 485.895 255.867 485.611 255.679 485.393Z",
    fill: "url(#paint86_linear_305_95636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.169 510.312C251.823 509.913 251.369 509.627 250.863 509.49C250.357 509.354 249.822 509.372 249.327 509.544C248.831 509.715 248.397 510.032 248.079 510.454C247.761 510.876 247.573 511.384 247.54 511.914C247.506 512.444 247.628 512.972 247.891 513.432C248.153 513.892 248.544 514.262 249.014 514.496C249.484 514.73 250.012 514.818 250.531 514.748C251.049 514.678 251.536 514.453 251.929 514.102C252.456 513.632 252.778 512.968 252.823 512.258C252.867 511.547 252.632 510.847 252.169 510.312Z",
    fill: "url(#paint87_linear_305_95636)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_95636",
    x1: 212.972,
    y1: 451.291,
    x2: 220.347,
    y2: 451.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_305_95636",
    x1: 225.923,
    y1: 454.83,
    x2: 230.324,
    y2: 454.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_305_95636",
    x1: 221.713,
    y1: 458.752,
    x2: 224.547,
    y2: 458.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_305_95636",
    x1: 253.394,
    y1: 450.183,
    x2: 256.228,
    y2: 450.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_305_95636",
    x1: 213.955,
    y1: 468.479,
    x2: 214.812,
    y2: 468.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_305_95636",
    x1: 231.827,
    y1: 466.435,
    x2: 232.684,
    y2: 466.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_305_95636",
    x1: 265.866,
    y1: 461.906,
    x2: 266.728,
    y2: 461.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_305_95636",
    x1: 260.35,
    y1: 465.714,
    x2: 261.208,
    y2: 465.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_305_95636",
    x1: 225.414,
    y1: 482.951,
    x2: 235.88,
    y2: 482.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_305_95636",
    x1: 240.737,
    y1: 462.343,
    x2: 245.939,
    y2: 462.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_305_95636",
    x1: 197.2,
    y1: 480.128,
    x2: 202.407,
    y2: 480.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_305_95636",
    x1: 225.806,
    y1: 423.744,
    x2: 231.008,
    y2: 423.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_305_95636",
    x1: 179.66,
    y1: 441.352,
    x2: 184.862,
    y2: 441.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_305_95636",
    x1: 187.988,
    y1: 405.841,
    x2: 190.496,
    y2: 405.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_305_95636",
    x1: 263.359,
    y1: 473.78,
    x2: 266.407,
    y2: 473.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_305_95636",
    x1: 220.068,
    y1: 475.38,
    x2: 223.115,
    y2: 475.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_305_95636",
    x1: 248.065,
    y1: 484.722,
    x2: 250.215,
    y2: 484.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_305_95636",
    x1: 253.454,
    y1: 453.094,
    x2: 255.604,
    y2: 453.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_305_95636",
    x1: 247.194,
    y1: 479.063,
    x2: 252.488,
    y2: 479.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_305_95636",
    x1: 208.4,
    y1: 403.433,
    x2: 215.775,
    y2: 403.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_305_95636",
    x1: 221.353,
    y1: 406.972,
    x2: 225.754,
    y2: 406.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_305_95636",
    x1: 217.143,
    y1: 410.891,
    x2: 219.977,
    y2: 410.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_305_95636",
    x1: 248.822,
    y1: 402.321,
    x2: 251.656,
    y2: 402.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_305_95636",
    x1: 209.385,
    y1: 420.617,
    x2: 210.243,
    y2: 420.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_305_95636",
    x1: 227.254,
    y1: 418.571,
    x2: 228.111,
    y2: 418.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_305_95636",
    x1: 261.296,
    y1: 414.043,
    x2: 262.158,
    y2: 414.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_305_95636",
    x1: 255.78,
    y1: 417.856,
    x2: 256.637,
    y2: 417.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_305_95636",
    x1: 220.843,
    y1: 435.088,
    x2: 231.309,
    y2: 435.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_305_95636",
    x1: 236.167,
    y1: 414.486,
    x2: 241.369,
    y2: 414.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_305_95636",
    x1: 192.627,
    y1: 432.266,
    x2: 197.834,
    y2: 432.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_305_95636",
    x1: 221.234,
    y1: 375.886,
    x2: 226.437,
    y2: 375.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_305_95636",
    x1: 175.088,
    y1: 393.494,
    x2: 180.29,
    y2: 393.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_305_95636",
    x1: 183.416,
    y1: 357.982,
    x2: 185.923,
    y2: 357.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_305_95636",
    x1: 258.788,
    y1: 425.923,
    x2: 261.835,
    y2: 425.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_305_95636",
    x1: 215.497,
    y1: 427.517,
    x2: 218.544,
    y2: 427.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_305_95636",
    x1: 243.494,
    y1: 436.859,
    x2: 245.645,
    y2: 436.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_305_95636",
    x1: 248.884,
    y1: 405.231,
    x2: 251.034,
    y2: 405.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_305_95636",
    x1: 242.622,
    y1: 431.205,
    x2: 247.915,
    y2: 431.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_305_95636",
    x1: 214.327,
    y1: 351.029,
    x2: 221.701,
    y2: 351.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_305_95636",
    x1: 227.276,
    y1: 354.568,
    x2: 231.682,
    y2: 354.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_305_95636",
    x1: 223.067,
    y1: 358.485,
    x2: 225.901,
    y2: 358.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_305_95636",
    x1: 254.748,
    y1: 349.921,
    x2: 257.582,
    y2: 349.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_305_95636",
    x1: 215.308,
    y1: 368.214,
    x2: 216.17,
    y2: 368.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_305_95636",
    x1: 233.181,
    y1: 366.173,
    x2: 234.038,
    y2: 366.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_305_95636",
    x1: 267.219,
    y1: 361.64,
    x2: 268.081,
    y2: 361.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_305_95636",
    x1: 261.706,
    y1: 365.453,
    x2: 262.563,
    y2: 365.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_305_95636",
    x1: 226.772,
    y1: 382.689,
    x2: 237.238,
    y2: 382.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_305_95636",
    x1: 242.093,
    y1: 362.082,
    x2: 247.299,
    y2: 362.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_305_95636",
    x1: 198.557,
    y1: 379.866,
    x2: 203.76,
    y2: 379.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_305_95636",
    x1: 227.16,
    y1: 323.483,
    x2: 232.366,
    y2: 323.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_305_95636",
    x1: 181.012,
    y1: 341.091,
    x2: 186.218,
    y2: 341.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_305_95636",
    x1: 189.34,
    y1: 305.579,
    x2: 191.848,
    y2: 305.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_305_95636",
    x1: 264.713,
    y1: 373.518,
    x2: 267.76,
    y2: 373.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_305_95636",
    x1: 221.421,
    y1: 375.114,
    x2: 224.472,
    y2: 375.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_305_95636",
    x1: 249.422,
    y1: 384.46,
    x2: 251.573,
    y2: 384.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_305_95636",
    x1: 254.809,
    y1: 352.828,
    x2: 256.96,
    y2: 352.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_305_95636",
    x1: 248.548,
    y1: 378.803,
    x2: 253.842,
    y2: 378.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_305_95636",
    x1: 195.614,
    y1: 302.637,
    x2: 202.993,
    y2: 302.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_305_95636",
    x1: 208.565,
    y1: 306.175,
    x2: 212.971,
    y2: 306.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_305_95636",
    x1: 204.356,
    y1: 310.094,
    x2: 207.19,
    y2: 310.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_305_95636",
    x1: 196.708,
    y1: 478.569,
    x2: 199.542,
    y2: 478.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_305_95636",
    x1: 196.599,
    y1: 319.821,
    x2: 197.46,
    y2: 319.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_305_95636",
    x1: 214.47,
    y1: 317.776,
    x2: 215.332,
    y2: 317.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_305_95636",
    x1: 209.18,
    y1: 490.288,
    x2: 210.038,
    y2: 490.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_305_95636",
    x1: 203.659,
    y1: 494.1,
    x2: 204.521,
    y2: 494.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_305_95636",
    x1: 208.061,
    y1: 334.292,
    x2: 218.527,
    y2: 334.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_305_95636",
    x1: 184.049,
    y1: 490.73,
    x2: 189.256,
    y2: 490.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_305_95636",
    x1: 194.858,
    y1: 337.512,
    x2: 200.065,
    y2: 337.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_305_95636",
    x1: 206.668,
    y1: 502.166,
    x2: 209.72,
    y2: 502.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_305_95636",
    x1: 202.71,
    y1: 326.722,
    x2: 205.762,
    y2: 326.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_305_95636",
    x1: 242.766,
    y1: 308.477,
    x2: 250.141,
    y2: 308.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_305_95636",
    x1: 255.719,
    y1: 312.015,
    x2: 260.124,
    y2: 312.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_305_95636",
    x1: 251.51,
    y1: 315.934,
    x2: 254.344,
    y2: 315.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_305_95636",
    x1: 243.752,
    y1: 325.661,
    x2: 244.614,
    y2: 325.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_305_95636",
    x1: 261.621,
    y1: 323.615,
    x2: 262.479,
    y2: 323.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_305_95636",
    x1: 255.214,
    y1: 340.133,
    x2: 265.68,
    y2: 340.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_305_95636",
    x1: 242.009,
    y1: 343.353,
    x2: 247.215,
    y2: 343.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_305_95636",
    x1: 249.862,
    y1: 332.56,
    x2: 252.914,
    y2: 332.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_305_95636",
    x1: 191.377,
    y1: 513.105,
    x2: 193.528,
    y2: 513.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_305_95636",
    x1: 196.765,
    y1: 481.476,
    x2: 198.916,
    y2: 481.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_305_95636",
    x1: 190.508,
    y1: 507.45,
    x2: 195.802,
    y2: 507.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_305_95636",
    x1: 253.737,
    y1: 483.206,
    x2: 256.571,
    y2: 483.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_305_95636",
    x1: 266.211,
    y1: 494.927,
    x2: 267.068,
    y2: 494.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_305_95636",
    x1: 260.689,
    y1: 498.738,
    x2: 261.551,
    y2: 498.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_305_95636",
    x1: 241.078,
    y1: 495.368,
    x2: 246.284,
    y2: 495.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_305_95636",
    x1: 263.697,
    y1: 506.805,
    x2: 266.749,
    y2: 506.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_305_95636",
    x1: 253.794,
    y1: 486.113,
    x2: 255.945,
    y2: 486.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_305_95636",
    x1: 247.532,
    y1: 512.088,
    x2: 252.831,
    y2: 512.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357A6B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_95636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 639,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_305_95636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 674.832,
    height: 503,
    fill: "white",
    transform: "translate(-135 136)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesMobileDark);
export default __webpack_public_path__ + "static/media/bubbles-mobile-dark.aeb87906cc493e1224ee6dbbe2667bd0.svg";
export { ForwardRef as ReactComponent };